import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { TextField, TableBody, Tooltip, TableRow, TableCell, Typography, lighten, IconButton, InputAdornment } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import { GcrRangeInput } from './GcrRangeInput';
const CenterAlignedCell = muiStyled(TableCell)({
    textAlign: 'center',
    cursor: 'pointer',
});
const FlexAlignedCell = muiStyled(TableCell)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    cursor: 'pointer',
});
;
const TableRows = ({ rows, colTitlesIndex, handleCellClick, handleRemoveRow, handleCellChange, handleCellBlur, handleCellKeyDown, }) => {
    return (_jsx(TableBody, { children: rows.slice(colTitlesIndex + 1).map((row, rowIndex) => (_jsx(TableRow, { "data-row-id": row.id, children: row.cells.map((cell, cellIndex) => {
                const firstCol = cellIndex === 0;
                const CellComponent = firstCol ? FlexAlignedCell : CenterAlignedCell;
                const styles = rowIndex === 0 && firstCol
                    ? { display: 'flex', justifyContent: 'flex-end' } : {};
                return (_jsxs(CellComponent, { onClick: () => handleCellClick(row.id, cellIndex), style: {
                        ...styles,
                        fontWeight: firstCol ? 'bold' : 'normal',
                        backgroundColor: cell.editable
                            ? '#fff'
                            : firstCol ? lighten('rgba(255, 99, 132, 1)', .4) : '#fff',
                    }, children: [firstCol && rowIndex > 0 &&
                            _jsx(Tooltip, { title: 'Delete Row', children: _jsx(IconButton, { "aria-label": 'Delete Row', onClick: () => handleRemoveRow(row.id), children: _jsx(DeleteIcon, {}) }) }), cell.editable ? (firstCol ? (_jsx(GcrRangeInput, { value: cell.value, onChange: (value) => handleCellChange(row.id, cellIndex, value), onBlur: () => handleCellBlur(row.id, cellIndex), onKeyDown: (e) => handleCellKeyDown(e, row.id, cellIndex) })) : (_jsx(TextField, { autoFocus: true, InputProps: {
                                startAdornment: _jsx(InputAdornment, { position: 'start', children: "%" }),
                            }, type: 'number', value: cell.value, onChange: (e) => handleCellChange(row.id, cellIndex, e.target.value), onBlur: () => handleCellBlur(row.id, cellIndex), onKeyDown: (e) => handleCellKeyDown(e, row.id, cellIndex) }))) : (_jsx(Typography, { fontWeight: firstCol ? 'bold' : 'normal', children: `${cell.value}${firstCol ? '' : '%'}` }))] }, cellIndex));
            }) }, row.id))) }));
};
export default memo(TableRows);
